export default {
  id: 1,
  subtitle: 'Send <b>{name}</b> a reminder:',
  items: [
    {
      id: 3,
      title: 'To do something',
      workflow: [
        { name: 'activity' },
        {
          name: 'remind',
          params: {
            title: 'Remind <b>{name}</b> to <b>do what</b>?',
            placeholder: 'e.g., read the handout I gave you',
            background: 'none',
          },
        },
        {
          name: 'name',
          params: { background: 'none' },
        },
        {
          name: 'channel',
          params: { title: 'Send Reminder By' },
        },
        {
          name: 'contact',
          params: { background: 'none' },
        },
        {
          name: 'date-time',
          params: {
            title: 'Select reminder date and time',
          },
        },
        {
          name: 'summary',
          params: {
            messages: {
              sms: `Hi {name}! Just wanted to remind you to {remind}.`,
              email: `Hi {name}! <br><br> This is a reminder from, {providerName}.<br><br> {remind}<br><br>Please contact your practitioner’s office if you have any questions about this message.`,
            },
            aliases: {
              date: 'date-time',
              time: 'date-time',
            },
          },
        },
        { name: 'scheduled' },
      ],
      notificationConfig: {
        type: 'once',
        times: ['19:00'],
        relativeNow: 72,
      },
    },
    {
      id: 6,
      title: 'For next appointment',
      workflow: [
        { name: 'activity' },
        {
          name: 'date-time',
          params: {
            title: 'Enter Appointment Time',
            subtitle: 'Reminder will be sent 24 hours before appointment time',
            background: 'none',
          },
        },
        {
          name: 'name',
          params: { background: 'none' },
        },
        {
          name: 'channel',
          params: { title: 'Send Appointment Reminder By' },
        },
        {
          name: 'contact',
          params: { background: 'none' },
        },
        {
          name: 'summary',
          params: {
            messages: {
              sms: `Your next appointment with {providerName} is on {nextAppointmentDate} at {nextAppointmentTime} {roomUrl}`,
              email: `Hi {name}! <br><br> Just wanted to remind you about your next appointment: <br>With {providerName}, {nextAppointmentDate} at {nextAppointmentTime}.<br><a href="{roomUrl}" target="_blank">{roomUrl}</a><br>Please check in a few minutes before your appointment using the button or link above.`,
            },
            aliases: {
              date: 'date-time',
              time: 'date-time',
            },
          },
        },
        { name: 'scheduled' },
      ],
      notificationConfig: {
        type: 'appointment',
        relativeDate: -24,
      },
    },
  ],
};
